<template>
  <v-app id="app">
    <Navigation/>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<style lang="scss">
$body-font-family: Avenir, Helvetica, Arial, sans-serif;

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 0px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.header-custom {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 9 !important;
}

nav {
  margin-top: 4rem !important;
}

main {
  margin-top: 1rem !important;
}

footer {
  position: absolute !important;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 99999 !important;
}
</style>

<script>
import Navigation from '@/layout/Navigation.vue';

export default {
  name: 'App',

  components: {
    Navigation
  },
  data: () => ({
    //
  }),
};
</script>
